import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

import { configureStore } from "./store";

// Ensure language is properly initialized
const initializeLanguage = () => {
  const storedLanguage = localStorage.getItem('I18N_LANGUAGE');
  if (!storedLanguage || (storedLanguage !== 'vi' && storedLanguage !== 'en')) {
    console.log('🔧 Setting default language to Vietnamese');
    localStorage.setItem('I18N_LANGUAGE', 'vi');
    i18n.changeLanguage('vi');
  } else {
    console.log('🔧 Using stored language:', storedLanguage);
    i18n.changeLanguage(storedLanguage);
  }
};

// Initialize language when app starts
initializeLanguage();

// Error Boundary Component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error caught by boundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <h1>Something went wrong.</h1>
          <button onClick={() => window.location.reload()}>
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
  <Provider store={configureStore({})}>
      <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
      </BrowserRouter>
      </I18nextProvider>
  </Provider>
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
